import React from "react";
import {Divider, Layout, Menu} from "antd";
import "./SideMenu.css"
import {Link, withRouter} from "react-router-dom";
import ExpandedLogoDarkMode from "../../layout/SideMenu/assets/side_menu_logo_expanded_dark_mode.png";
import ExpandedLogo from "../../layout/SideMenu/assets/side_menu_logo_expanded.png";
import SideMenuContainer from "../../layout/SideMenu/SideMenu.style";
import DynamicIcon from "../../components/DynamicIcon";

const {SubMenu} = Menu;

const SideMenu = ({menu, menuItems, location, history, theme,  primaryColor}) => {
    const darkMode = theme === 'dark';

    const renderMenuItem = ({key, icon, value, divider}) => {
        return divider ?
            <Menu.ItemGroup key={value} title={
                <Divider>{value}</Divider>}/> : (
                <Menu.Item key={key}>
                    <Link to={`/${key}`}> {icon && <DynamicIcon size={'large'} type={icon}/>}
                        <span>{value}</span>
                    </Link>
                </Menu.Item>
            );
    };

    const renderMenuItems = () => {
        const items = menuItems || [];
        return items.map(item => {
            if (!item.subItems || item.subItems.length === 0) {
                return item.hideFromMenu ? null : renderMenuItem(item);
            } else {
                return (
                    <SubMenu
                        key={item.key}
                        title={
                            <span>
                                <span>{item.value}</span>
                            </span>
                        }
                    >
                        {item.subItems.map(subItem => renderMenuItem(subItem))}
                    </SubMenu>
                );
            }
        });
    };

    const path = location.pathname;
    const item = path !== "/" ? path.substr(1) : menuItems[0].key || null;
    return (
        <Layout.Sider
            className="sidebar"
            breakpoint={"lg"}
            theme="light"
            collapsedWidth={0}
            trigger={null}
        >

            <SideMenuContainer darkMode={darkMode}>
                <Link to={'/'} className="logo-wrapper">
                    {
                        <img src={darkMode ? ExpandedLogoDarkMode : ExpandedLogo} alt="logo"
                             className="side-menu-logo"/>
                    }
                </Link>

                <Menu theme={theme} defaultSelectedKeys={[item]} mode="inline">
                    {renderMenuItems()}
                </Menu>
            </SideMenuContainer>
        </Layout.Sider>
    );
};

export default withRouter(SideMenu);